/* Add to cart from a collection card.
   The bar is a SIBLING of the links, never nested inside an anchor —
   interactive elements inside an anchor is what broke the last attempt.
   No size picker here: one variant adds, several open the product page. */
(() => {
  'use strict';
  document.addEventListener('click', (e) => {
    const bar = e.target.closest('[data-atc]');
    if (!bar || bar.disabled) return;
    if (bar.dataset.single !== 'true') { window.location.href = bar.dataset.href; return; }
    bar.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(bar.dataset.variant), quantity: 1 }] }),
    })
      .then((r) => {
        if (!r.ok) throw new Error('Could not add product to cart');
        return r.json();
      })
      .then(() => {
        sessionStorage.setItem('sadil:open-cart', '1');
        window.location.reload();
      })
      .catch(() => { window.location.href = bar.dataset.href; })
      .finally(() => { bar.disabled = false; });
  });
})();
